import API from 'api.js';

/**
 * Load full mock data.
 */
const loadFullMockApi = async (id, pending, history) => {	
	return await API({
		method: 'GET',
		url: `web/question/detail/${id}/${pending}`
	})
	.then(data => {
		if ('code' in data.data && data.data.code === 'F') {
			return history.push("/admin/unauthorized");
		}

		return data.data;
	});
};

/**
 * Submit mock Question.
 */
const submitMockQuestionApi = async (formData) => {
	return await API({
		method: 'POST',
		url: `submit/mock`,
		data: formData
	}).then(data => {
		return data;
	}).catch(err => {
		return false;
	});
};


/**
 * Save & Exit Api.
 */
const saveAndExitApi = (formData) => {
	API({
		method: 'POST',
		url: `submit/mock`,
		data: formData
	});
};


/**
 * TimeOut Api.
 */
const sectionTimeOutApi = (formData) => {
	API({
		method: 'Post',
		url: 'set/mockTime',
		data: formData
	});
};

export default loadFullMockApi;
export {
	submitMockQuestionApi,
	saveAndExitApi,
	sectionTimeOutApi
};